import './index.scss'
import React from 'react'
import Content from '../../../components/content/index'
import Editable from "../../../components/editable/index"

// 头条
const Welcome = (props) => {
  return [{
    uid: 'welcome-1',
    name: '头条',
    component: Welcome1,
    html: <Welcome1 {...props} />
  }, {
    uid: 'welcome-2',
    name: '带视频播放的头条',
    component: Welcome2,
    html: <Welcome2 {...props} />
  }]
}

export default Welcome

const Welcome1 = (props) => {
  return (
    <div className="section-hero">
      <div className="section-background-wrap">
        <img className="media-image" src={props.media.type === 'video' ? props.media.cover : props.media.src} alt={props.media.caption} />
      </div>
      
      <div className="va-container">
        <div className="va-middle">
          <div className="container">
            <div className="section-desc-wrap">
              {!props.title.is_hidden && <h2 className="section-title">{props.title.content}</h2>}
              {!props.subtitle.is_hidden && <h4 className="section-subtitle">{props.subtitle.content}</h4>}
              {!props.paragraph.is_hidden && <div className="section-desc">{props.paragraph.content}</div>}

              {
                !props.button.is_hidden &&
                <div className="actions-wrap">
                  <a href={props.button.link} className="btn btn-primary">
                    { props.button.title }
                    <img className="icon-right" src="http://static.dian.in/assets/icons/arrow-right-white.png" />
                  </a>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const Welcome2 = (props) => {
  return (
    <div className="section-welcome section-welcome-with-player">
      <div className="section-background-wrap">
        <img className="media-image" src={props.media.type === 'video' ? props.media.cover : props.media.src} alt={props.media.caption} />
      </div>
      <div className="section-header">
        <div className="container text-center">
          {!props.subtitle.is_hidden && <h4 className="section-subtitle">{props.subtitle.content}</h4>}
          {!props.title.is_hidden && <h2 className="section-title">{props.title.content}</h2>}
          {
            props.media.type === 'video' &&
            <div className="section-player-wrap">
              <button className="btn-link" onClick={() => props.openVideoPlayer(props.media.iframe)}>
                <span className="sr-only">{props.media.title}</span>
                <i className="fi fi-play"> </i>
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/section/welcome/index.js